// src/services/mockOrderService.js

// 輔助函數：生成隨機日期 (過去一年內)
function getRandomPastDate() {
  const end = new Date();
  const start = new Date();
  start.setFullYear(start.getFullYear() - 1);
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
}

// 輔助函數：生成隨機訂單號
function generateOrderSn() {
  return `SN${Date.now()}${Math.floor(Math.random() * 1000)}`;
}

// 模擬的商品數據 (可以從你的商品列表中取一些)
const mockProducts = [
  { productId: 'P001', productName: '潮流復古運動鞋 AF100', productImage: 'static/dior衣服/1748329912849_44460_海苔胶囊(60粒)-详情图-2.20240928.jpg', priceAtPurchase: 799, sku: '白色 / EU 42' },
  { productId: 'P002', productName: '限量版籃球鞋 JDN23', productImage: 'static/dior衣服/1748329912849_44460_海苔胶囊(60粒)-详情图-2.20240928.jpg', priceAtPurchase: 1299, sku: '黑紅 / EU 43' },
  { productId: 'P003', productName: '舒適日常跑鞋 RNR05', productImage: 'static/dior衣服/1748329912849_44460_海苔胶囊(60粒)-详情图-2.20240928.jpg', priceAtPurchase: 599, sku: '灰色 / EU 40' },
  { productId: 'P004', productName: '經典帆布休閒鞋 CVAS', productImage: 'static/dior衣服/1748329912849_44460_海苔胶囊(60粒)-详情图-2.20240928.jpg', priceAtPurchase: 399, sku: '黑色 / EU 38' },
  { productId: 'P005', productName: '戶外徒步登山鞋 HIKER', productImage: 'static/dior衣服/1748329912849_44460_海苔胶囊(60粒)-详情图-2.20240928.jpg', priceAtPurchase: 999, sku: '軍綠 / EU 44' },
];

// 模擬的收貨地址
const mockAddresses = [
    { recipientName: '張三', phoneNumber: '13800138000', fullAddress: '北京市海淀區中關村大街1號軟件園A座101室', email: 'zhangsan@example.com' },
    { recipientName: '李四', phoneNumber: '13900139000', fullAddress: '上海市浦東新區世紀大道2001號國金中心B座202室', email: 'lisi@example.com' },
];

// 模擬的物流信息
const mockLogistics = [
    { provider: '順豐速運', trackingNumber: 'SF1234567890123' },
    { provider: '圓通快遞', trackingNumber: 'YT0987654321098' },
];

const mockOrderStatusPool = ['pending_payment', 'processing', 'shipped', 'delivered', 'completed', 'cancelled'];
const mockPaymentMethods = ['ct_payment', 'credit_card'];

// 生成一個模擬訂單項
function createMockOrderItem(productIndex) {
  const product = mockProducts[productIndex % mockProducts.length];
  return {
    id: `ITEM-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`,
    productId: product.productId,
    productName: product.productName,
    productImage: product.productImage,
    sku: product.sku,
    quantity: Math.floor(Math.random() * 3) + 1,
    priceAtPurchase: product.priceAtPurchase,
  };
}

// 生成一個完整的模擬訂單
let orderIdCounter = 1;
function createMockOrder() {
  const numItems = Math.floor(Math.random() * 3) + 1; // 1到3個商品
  const items = [];
  for (let i = 0; i < numItems; i++) {
    items.push(createMockOrderItem(Math.floor(Math.random() * mockProducts.length)));
  }

  const subtotal = items.reduce((sum, item) => sum + item.priceAtPurchase * item.quantity, 0);
  const shippingFee = Math.random() > 0.7 ? 0 : (Math.floor(Math.random() * 2) + 1) * 10; // 0元或10-20元運費
  const totalAmount = subtotal + shippingFee;
  const status = mockOrderStatusPool[Math.floor(Math.random() * mockOrderStatusPool.length)];
  const address = mockAddresses[Math.floor(Math.random() * mockAddresses.length)];

  let logisticsInfo = null;
  if (status === 'shipped' || status === 'delivered' || status === 'completed') {
    logisticsInfo = {
        ...mockLogistics[Math.floor(Math.random() * mockLogistics.length)],
        shippedAt: getRandomPastDate().toISOString(),
    }
  }


  return {
    id: orderIdCounter++, // 使用自增 ID
    orderSn: generateOrderSn(),
    createdAt: getRandomPastDate().toISOString(),
    status: status,
    // statusText: getOrderStatusText(status), // statusText 可以在組件中生成
    totalAmount: parseFloat(totalAmount.toFixed(2)),
    paymentMethod: mockPaymentMethods[Math.floor(Math.random() * mockPaymentMethods.length)],
    items: items,
    shippingAddress: address,
    logisticsInfo: logisticsInfo,
    notes: Math.random() > 0.8 ? '請盡快發貨，謝謝！' : (Math.random() > 0.9 ? '需要禮品包裝。' : ''),
  };
}

// 模擬的訂單數據庫
const mockUserOrdersDB = [];
const TOTAL_MOCK_ORDERS = 23; // 模擬的總訂單數量
for (let i = 0; i < TOTAL_MOCK_ORDERS; i++) {
  mockUserOrdersDB.push(createMockOrder());
}
// 按創建時間降序排列
mockUserOrdersDB.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());


const mockOrderService = {
  async getUserOrders(params = { page: 1, page_size: 5 }) {
    console.log('Mock Service: getUserOrders called with params:', params);
    return new Promise((resolve) => {
      setTimeout(() => {
        const { page = 1, page_size = 5 } = params;
        const start = (page - 1) * page_size;
        const end = start + page_size;
        const paginatedOrders = mockUserOrdersDB.slice(start, end);

        resolve({
          items: paginatedOrders,
          total: mockUserOrdersDB.length, // 總項目數
          page: Number(page),
          pageSize: Number(page_size),
          // pages: Math.ceil(mockUserOrdersDB.length / page_size) // 總頁數 (可選)
        });
      }, 500 + Math.random() * 800); // 模擬網絡延遲
    });
  },

  async cancelUserOrder(orderId) {
    console.log('Mock Service: cancelUserOrder called for orderId:', orderId);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const orderIndex = mockUserOrdersDB.findIndex(o => o.id === orderId);
        if (orderIndex !== -1) {
          const order = mockUserOrdersDB[orderIndex];
          if (order.status === 'pending_payment' || order.status === 'processing') {
            order.status = 'cancelled';
            // order.statusText = getOrderStatusText('cancelled'); // 如果需要更新 statusText
            resolve({ success: true, message: '訂單已取消' });
          } else {
            reject({ response: { data: { detail: '該訂單狀態無法取消' } } });
          }
        } else {
          reject({ response: { data: { detail: '訂單未找到' } } });
        }
      }, 300 + Math.random() * 500);
    });
  },

  async confirmOrderReceipt(orderId) {
    console.log('Mock Service: confirmOrderReceipt called for orderId:', orderId);
     return new Promise((resolve, reject) => {
      setTimeout(() => {
        const orderIndex = mockUserOrdersDB.findIndex(o => o.id === orderId);
        if (orderIndex !== -1) {
          const order = mockUserOrdersDB[orderIndex];
          if (order.status === 'shipped') {
            order.status = 'delivered'; // 或 'completed'，取決於你的流程
            // order.statusText = getOrderStatusText('delivered');
            resolve({ success: true, message: '已確認收貨' });
          } else {
            reject({ response: { data: { detail: '訂單狀態不符，無法確認收貨' } } });
          }
        } else {
          reject({ response: { data: { detail: '訂單未找到' } } });
        }
      }, 300 + Math.random() * 500);
    });
  },

  // 你可以根據需要添加 getOrderDetail 的 mock
  async getOrderDetail(orderId) {
    console.log('Mock Service: getOrderDetail called for orderId:', orderId);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const order = mockUserOrdersDB.find(o => o.id === Number(orderId)); // 假設 orderId 是數字
        if (order) {
          resolve(order); // 直接返回訂單對象
        } else {
          reject({ response: { status: 404, data: { detail: '訂單詳情未找到' } } });
        }
      }, 300 + Math.random() * 500);
    });
  }
};

export default mockOrderService;